const state = {
  visitedViews: []
}

const mutations = {
  ADD_VIEW(state, view) {
    if (state.visitedViews.some(v => v.path === view.path)) return
    state.visitedViews.push({
      title: view.meta.title || '未命名',
      path: view.path,
      name: view.name,
      fullPath: view.fullPath
    })
  },
  DEL_VIEW(state, view) {
    const i = state.visitedViews.findIndex(v => v.path === view.path)
    if (i > -1) state.visitedViews.splice(i, 1)
  },
  DEL_OTHERS(state, view) {
    state.visitedViews = state.visitedViews.filter(v => v.path === view.path || v.path === '/dashboard')
  },
  DEL_ALL(state) {
    state.visitedViews = state.visitedViews.filter(v => v.path === '/dashboard')
  }
}

export default { namespaced: true, state, mutations }
